import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Input, Collapse, Select, Spin } from 'antd';
import { isEmpty } from 'lodash';

import { marginatorActions, Impersonate, ErrorType } from '@share/store/slices';
import { RootState } from '@share/utils';
import { BlueButton } from '@share/components';

import './style.scss';

interface IProps {
  isCars?: boolean;
}

export function Impersonator(props: IProps) {
  const { Panel } = Collapse;
  const { isCars } = props;
  
  const dispatch = useDispatch();

  const loginStore = useSelector((state: RootState) => state.loginStore);

  const { error, account, loading, loadingImpersonate } = loginStore;

  const [show, setShow] = useState(account?.isTravelAgentPro || account?.forceImpersonate);
  const [member, setMember] = useState('');
  const [storeType, setStoreType] = useState('');

  useEffect(() => {
    setShow(account?.isTravelAgentPro || account?.forceImpersonate);
  }, [])

  useEffect(() => {
    setShow(account?.isTravelAgentPro || account?.forceImpersonate);
  }, [loading])

  const handleChange = (e: { target: HTMLInputElement }): void => {
    setMember(e.target.value);
  }

  const handleStoreChange = (value: string): void => {
    setStoreType(value);
  }

  const handleApply = (e: React.ChangeEvent<any>) => {
    e.preventDefault();
    dispatch(marginatorActions.setMemberId(Number(member)));
    dispatch(marginatorActions.setStoreType(isEmpty(storeType) ? undefined : storeType));
    if (!isEmpty(member) && (!account?.isCapitalVacations || !isEmpty(storeType))) {
      dispatch(Impersonate(false, isCars));
    }
  }
  
  return (
    <>
      {show && (
        <Collapse className="impersonate-container" defaultActiveKey={account?.forceImpersonate ? ['1'] : []} ghost expandIconPosition='right'>
          <Panel header="Impersonate Member" key="1">
            <div className="member-code__wrapper mt-2 member-code__form">
              {account?.isCapitalVacations ? (
                <Select style={{padding: '0 11px', width: '100%'}}
                  placeholder={'Enter store type'}
                  value={storeType}
                  onChange={(value) => handleStoreChange(value)}
                >
                  <Select.Option value={'value'}>Value</Select.Option>
                  <Select.Option value={'choice'}>Choice</Select.Option>
                  <Select.Option value={'unlimited'}>Unlimited</Select.Option>
                </Select>) : null}
              <Input
                className={`member-code__input`}
                placeholder="Enter member id"
                type={'number'}
                onChange={handleChange}
                value={member}
              />
              <BlueButton disabled={isEmpty(member) || (account?.isCapitalVacations && isEmpty(storeType)) || loadingImpersonate} onClick={(e) => { handleApply(e) }}>
                {loadingImpersonate ? (<Spin />) : (<FormattedMessage id="apply" />)}
              </BlueButton>
            </div>
            {error?.type === ErrorType.ImpersonatorInvalidMemberId && <p className='error'>{error.error}</p>}
          </Panel>
        </Collapse>
      )}
    </>
  );
}
